var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['text-message']},[_vm._v(" Ma localisation 📍 ")])}
var staticRenderFns = []

export { render, staticRenderFns }